export const CODE_VALUES = {
  I: 'Integer',
  S: 'String',
  C: 'Char',
  B: 'Boolean',
  N: 'Numeric',
} as const;